import InputGroup from 'bee-input-group'

export default InputGroup
